// src/components/Quotation/QuotationEditModal.jsx
import React, { useState } from "react";
import { updateQuotation } from "../../api/quotationApi";
import { useCurrentUser } from "../../context/UserContext";

const QuotationEditModal = ({ quotation, onClose, onSuccess }) => {
  const { currentUser } = useCurrentUser();
  const [form, setForm] = useState({
    quoteNumber:  quotation.quoteNumber  || "",
    quoteDate:    quotation.quoteDate    || "",
    vendorName:   quotation.vendorName   || "",
    notes:        quotation.notes        || "",
    totalAmount:  quotation.totalAmount  || 0,
    totalCGST:    quotation.totalCGST    || 0,
    totalSGST:    quotation.totalSGST    || 0,
    totalIGST:    quotation.totalIGST    || 0,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState("");

  const handleSubmit = async () => {
    if (!form.quoteNumber.trim()) return setError("Quote number is required.");
    setLoading(true);
    setError("");
    try {
      const body = {
        ...form,
        status:       quotation.status,         // keep existing status
        usercid:      currentUser?.id,
        useradminid:  currentUser?.useradminid,
        purchaseOrderId: quotation.purchaseOrderId
      };
      const res = await updateQuotation(quotation.id, body);
      if (res.ok) {
        onSuccess();
        onClose();
      } else {
        const err = await res.json();
        setError(err.message || `Error ${res.status}`);
      }
    } catch (e) {
      setError("Network error.");
    } finally {
      setLoading(false);
    }
  };

  const field = (label, key, type = "text") => (
    <div style={{ marginBottom: 14 }}>
      <label style={labelStyle}>{label}</label>
      <input
        type={type}
        style={inputStyle}
        value={form[key]}
        onChange={e => setForm(f => ({ ...f, [key]: e.target.value }))}
      />
    </div>
  );

  return (
    <div style={overlay}>
      <div style={{ ...modal, maxHeight: "85vh", display: "flex", flexDirection: "column" }}>
        <div style={modalHeader}>
          <span style={{ fontSize: 15, fontWeight: 600 }}>Edit Quotation</span>
          <button onClick={onClose} style={closeBtn}>✕</button>
        </div>
        <div style={{ padding: "20px", overflowY: "auto", flex: 1 }}>
          {field("Quote Number *", "quoteNumber")}
          {field("Quote Date", "quoteDate", "date")}
          {field("Vendor Name", "vendorName")}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
            {field("Total Amount", "totalAmount", "number")}
            {field("Total CGST", "totalCGST", "number")}
            {field("Total SGST", "totalSGST", "number")}
            {field("Total IGST", "totalIGST", "number")}
          </div>
          <div style={{ marginBottom: 14 }}>
            <label style={labelStyle}>Notes</label>
            <textarea
              style={{ ...inputStyle, height: 80, resize: "vertical" }}
              value={form.notes}
              onChange={e => setForm(f => ({ ...f, notes: e.target.value }))}
            />
          </div>
          {error && <div style={errorBox}>{error}</div>}
        </div>
        <div style={modalFooter}>
          <button onClick={onClose} style={cancelBtn}>Cancel</button>
          <button onClick={handleSubmit} disabled={loading} style={submitBtn}>
            {loading ? "Saving..." : "Save Changes"}
          </button>
        </div>
      </div>
    </div>
  );
};

const overlay     = { position:"fixed",inset:0,background:"rgba(0,0,0,0.45)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000 };
const modal       = { background:"#fff",borderRadius:14,width:"100%",maxWidth:520,boxShadow:"0 8px 32px rgba(0,0,0,0.12)" };
const modalHeader = { display:"flex",justifyContent:"space-between",alignItems:"center",padding:"16px 20px",borderBottom:"0.5px solid #E5E7EB" };
const closeBtn    = { background:"none",border:"none",cursor:"pointer",fontSize:16,color:"#6B7280" };
const modalFooter = { display:"flex",justifyContent:"flex-end",gap:10,padding:"14px 20px",borderTop:"0.5px solid #E5E7EB" };
const labelStyle  = { display:"block",fontSize:12.5,fontWeight:500,color:"#374151",marginBottom:5 };
const inputStyle  = { width:"100%",padding:"9px 12px",borderRadius:8,border:"0.5px solid #D1D5DB",fontSize:13,outline:"none",boxSizing:"border-box" };
const errorBox    = { fontSize:12.5,color:"#EF4444",background:"#FEF2F2",border:"0.5px solid #FECACA",borderRadius:8,padding:"8px 12px" };
const cancelBtn   = { fontSize:13,padding:"7px 16px",borderRadius:8,background:"#F9FAFB",border:"0.5px solid #D1D5DB",color:"#374151",cursor:"pointer" };
const submitBtn   = { fontSize:13,fontWeight:600,padding:"7px 20px",borderRadius:8,background:"#1A56DB",color:"#fff",border:"none",cursor:"pointer" };

export default QuotationEditModal;
